import { AxiosInstance } from "axios";
import { ResponseDto } from "@common/ict/model/interface/common";

export class ProductApi {
  //  政企用户/高校用户/合作伙伴导航栏
  static getTrainingNewsList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/gov/training/dynamic/page/list`,
      {
        params: query
      }
    );
  }
  static getClassification(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/gov/carousel/page/list`,
      {
        params: query
      }
    );
  }
  static getSuccessCase(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/gov/success/cases/page/list`,
      {
        params: query
      }
    );
  }
  static getSolutionList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/gov/solution/page/list`,
      {
        params: query
      }
    );
  }
}
